/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ItemTypes = 'Product' | 'Service' | 'ConstructionMain' | 'ConstructionSecondary';

export const ItemTypes = {
    Product: 'Product' as ItemTypes,
    Service: 'Service' as ItemTypes,
    ConstructionMain: 'ConstructionMain' as ItemTypes,
    ConstructionSecondary: 'ConstructionSecondary' as ItemTypes
};

